import Scheme from '../../components/BudgetAllocation/Schemes/SchemeDetails'

const SchemeDetails = () => {
  return (
    <div>
        <Scheme></Scheme>
    </div>
  )
}

export default SchemeDetails